import { EnvironmentId } from "./types";
import { getOrInitAppStateStorage, setAppStateStorage } from "./appState";

let selectedEnvironmentId = getOrInitAppStateStorage().selectedEnvAssociationId;

export function getSelectedEnvironmentId() {
	return selectedEnvironmentId;
}

/**
 * Makes requests from this window use the given environment without changing the stored selection, for example so a
 * Custom App popup keeps its opener's environment after another tab selects a different one.
 */
export function setWindowEnvironmentId(environmentId: EnvironmentId) {
	selectedEnvironmentId = environmentId;
}

export const setSelectedEnvironmentId = (environmentId: EnvironmentId) => {
	const appState = getOrInitAppStateStorage();
	setAppStateStorage({ ...appState, selectedEnvAssociationId: environmentId });
	window.location.reload();
};
